// extracted by mini-css-extract-plugin
module.exports = {"control":"Toggle_control__21Ti_","input":"Toggle_input__rpbO2"};